import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";
import { ButtonComponent } from "../button/button.component";

@Component({
  selector: "app-empty",
  imports: [ButtonComponent],
  templateUrl: "./empty.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: "./empty.component.scss",
})
export class EmptyComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string | undefined> = input<string | undefined>();
  public readonly buttonLabel: InputSignal<string | undefined> = input<string | undefined>();

  public readonly buttonAction: OutputEmitterRef<void> = output<void>();

  public onButtonAction(): void {
    this.buttonAction.emit();
  }
}
